import { Routes } from '@datadog/browser-rum-react/cjs/entries/reactRouter';
import { Trans } from '@lingui/react/macro';
import { Route } from 'react-router-dom';

import { Qonto } from './Qonto/Qonto';
import { GenericError } from '../components/GenericError/GenericError';

export const Connect = () => {
  return (
    <Routes>
      <Route path="/qonto" element={<Qonto />} />
      <Route
        path="/*"
        element={<GenericError errorText={<Trans>Page not found.</Trans>} />}
      />
    </Routes>
  );
};
